/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import '../style/timwlinw.css'

const Timeline = () => {
    return (
        <>
            <div className='container'>
                <div className='ok' style={{ display: 'flex', justifyContent: 'center', marginTop: '75px' }} data-aos="fade-up" data-aos-offset="250" data-aos-duration="1500" mirror='true'>
                    <h2 style={{ padding: '7px', color: '#00415d' }}>My Career Journey  </h2>
                </div>
            </div>
            <div className='container' id='contT'>
                <div className="hr-line mt-4 mb-4"></div>
                <div className="container pt-5">
                    <div className="main-timeline">
                        {/* <!--1st section--> */}
                        <div className="timeline-item d-flex flex-row flex-wrap justify-content-center align-items-center">
                            <div className="date-content order_1b">
                                <div className="date-outer">
                                    <span className="date">
                                        <p className="year pt-2">2011</p>
                                    </span>
                                </div>
                            </div>
                            <div className="icon order_2b"></div>
                            <div className="timeline-content order_3b col-md p-3">
                                <h5 className="title pt-4 fw-bold">Early Beginnings</h5>
                                <p className="description">
                                    Raised by a determined single mother after my father's passing, I inherited the spirit of entrepreneurship. Education became my compass for success.
                                </p>
                            </div>
                        </div>
                        {/* <!--1st section--> */}
                        {/* <!--2nd section--> */}
                        <div className="timeline-item d-flex flex-row flex-wrap justify-content-center align-items-center">
                            <div className="date-content order_1">
                                <div className="date-outer">
                                    <span className="date">
                                        <p className="year pt-2">2012</p>
                                    </span>
                                </div>
                            </div>
                            <div className="icon order_2"></div>
                            <div className="timeline-content order_3 col-md p-3">
                                <h5 className="title pt-4 fw-bold">First Attempt</h5>
                                <p className="description">
                                    Launched H2O Academy, but it sank. Doubts flooded in from all directions.
                                </p>
                            </div>
                        </div>
                        {/* <!--2nd section--> */}
                        {/* <!--3rd section--> */}
                        <div className="timeline-item d-flex flex-row flex-wrap justify-content-center align-items-center">
                            <div className="date-content order_1b">
                                <div className="date-outer">
                                    <span className="date">
                                        <p className="year pt-2">2013</p>
                                    </span>
                                </div>
                            </div>
                            <div className="icon order_2b"></div>
                            <div className="timeline-content order_3b col-md p-3">
                                <h5 className="title pt-4 fw-bold">Education Triumph</h5>
                                <p className="description">
                                    Despite academic struggles, I conquered my CA and other qualifications, securing a job for survival.
                                </p>
                            </div>
                        </div>
                        {/* <!--3rd section--> */}
                        <div className="timeline-item d-flex flex-row flex-wrap justify-content-center align-items-center">
                            <div className="date-content order_1">
                                <div className="date-outer">
                                    <span className="date">
                                        <p className="year pt-2">2019</p>
                                    </span>
                                </div>
                            </div>
                            <div className="icon order_2"></div>
                            <div className="timeline-content order_3 col-md p-3">
                                <h5 className="title pt-4 fw-bold">Career Crossroads</h5>
                                <p className="description">
                                    Tried various jobs, searching for my true calling. The entrepreneurial itch persisted.
                                </p>
                            </div>
                        </div>
                        <div className="timeline-item d-flex flex-row flex-wrap justify-content-center align-items-center">
                            <div className="date-content order_1b">
                                <div className="date-outer">
                                    <span className="date">
                                        <p className="year pt-2">2020</p>
                                    </span>
                                </div>
                            </div>
                            <div className="icon order_2b"></div>
                            <div className="timeline-content order_3b col-md p-3">
                                <h5 className="title pt-4 fw-bold">Dark Days</h5>
                                <p className="description">
                                    Business failures and job dissatisfaction led to a downward spiral of depression.
                                </p>
                            </div>
                        </div>
                        <div className="timeline-item d-flex flex-row flex-wrap justify-content-center align-items-center">
                            <div className="date-content order_1">
                                <div className="date-outer">
                                    <span className="date">
                                        <p className="year pt-2">2021</p>
                                    </span>
                                </div>
                            </div>
                            <div className="icon order_2"></div>
                            <div className="timeline-content order_3 col-md p-3">
                                <h5 className="title pt-4 fw-bold">Resilience Unleashed</h5>
                                <p className="description">
                                    Refused to surrender. Juggled multiple jobs, faced failures head-on, and rebuilt my CA practice.
                                </p>
                            </div>
                        </div>
                        <div className="timeline-item d-flex flex-row flex-wrap justify-content-center align-items-center">
                            <div className="date-content order_1b">
                                <div className="date-outer">
                                    <span className="date">
                                        <p className="year pt-2">2023</p>
                                    </span>
                                </div>
                            </div>
                            <div className="icon order_2b"></div>
                            <div className="timeline-content order_3b col-md p-3">
                                <h5 className="title pt-4 fw-bold">Triumph Emerges</h5>
                                <p className="description">
                                    After relentless effort, my CA firm flourishes. Embraced mentorship, honed skills, and automated processes to craft a thriving business model.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
            </div>
        </>
    )
}

export default Timeline
